import { QueryClient } from '@tanstack/react-query';
import { onMutationError, onQueryError } from '@/lib/query-error-handler';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      onError: onMutationError,
    },
  },
});

queryClient.getQueryCache().config.onError = onQueryError;
